import type { SVGProps } from 'react';
const SvgPlug = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.286 3c.475 0 .857.393.857.882v3.824h5.714V3.882c0-.489.382-.882.857-.882s.857.393.857.882v3.824h2.572c.475 0 .857.393.857.882a.87.87 0 0 1-.857.883h-.286v2.94c0 3.6-2.618 6.57-6 7.004v2.703A.87.87 0 0 1 13 23a.87.87 0 0 1-.857-.882v-2.703c-3.382-.433-6-3.404-6-7.003V9.47h-.286A.87.87 0 0 1 5 8.588c0-.489.382-.882.857-.882H8.43V3.882c0-.489.382-.882.857-.882M7.857 9.47v2.942c0 2.923 2.304 5.294 5.143 5.294s5.143-2.371 5.143-5.294V9.47z"
    />
  </svg>
);
export default SvgPlug;
